// extracted by mini-css-extract-plugin
export default {"cls1":"jsnBOqRjNw9dNQ1zcp7t","cls2":"fHfu7C2EgOBwwn6sZ9d4 jsnBOqRjNw9dNQ1zcp7t","isPhone":"ZStT0v0XMunwOYoQkVjS"};